module.exports = __webpack_public_path__ + "images/category_lp/macbook/store_images/3_feace1f21ca07ac99d851e4cfea9dc15.png";